import {
  FeatureFlags,
  FeatureFlagWithExperiment,
} from 'js/sign-components/common/feature-flags';

type FeatureFlagValue = boolean | FeatureFlagWithExperiment | undefined;

export function checkFeatureFlag(
  name: keyof FeatureFlags,
  featureFlags: FeatureFlags,
): boolean {
  const value = featureFlags[name] as FeatureFlagValue;
  if (value === undefined) {
    return false;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (isFeatureFlagWithExperiment(value)) {
    return value.status;
  }
  return false;
}

export function hasFeatureFlagFactory(featureFlags: FeatureFlags) {
  return function hasFeatureFlag(name: keyof FeatureFlags): boolean {
    return checkFeatureFlag(name, featureFlags);
  };
}

function isFeatureFlagWithExperiment(
  obj: unknown,
): obj is FeatureFlagWithExperiment {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    typeof (obj as any).status === 'boolean' &&
    typeof (obj as any).inExperiment === 'boolean' &&
    'values' in obj &&
    ((obj as any).variationId === undefined ||
      typeof (obj as any).variationId === 'number') &&
    ((obj as any).key === undefined || typeof (obj as any).key === 'string')
  );
}

export function getFeatureFlagWithExperiment(
  name: keyof FeatureFlags,
  featureFlags: FeatureFlags,
): FeatureFlagWithExperiment | null {
  const value = featureFlags[name] as FeatureFlagValue;
  if (!isFeatureFlagWithExperiment(value)) {
    return null;
  }
  return value;
}
